import ContactAPI from '@/api/contact'
// initial state
const state = () => ({
  contacts: [],
  customers: [],
  suppliers: [],
  selected: null
})

// getters
const getters = {
  selected: (state) => state.selected,
  contacts: (state) => state.contacts,
  customers: (state) => state.customers,
}

// actions
const actions = {
  async loadContacts ({ commit }) {
    const result = await ContactAPI.loadContacts()
    const contacts = result.data.map(contact => {
      // contact.isSelectable = contact.marketingCategory.includes('UNDEFINED')
      return contact
    })
    const customers = result.data.filter(contact => ["CUSTOMER","BOTH","NEITHER"].includes(contact.contactType))
    commit('setContacts', contacts)
    commit('setCustomers', customers)
  },
  setSelected({ commit }, selected) {
    commit('setSelected', selected)
  }
}

// mutations
const mutations = {
  setContacts (state, contacts) {
    state.contacts = contacts
  },
  setCustomers (state, customers) {
    state.customers = customers
  },
  setSelected(state, selected) {
    state.selected = selected
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
